var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      ref: "callFlowCanvas",
      staticClass: "cf-canvas",
      class: { "cf-canvas--node-select-mode": _vm.goToNodeSelectMode },
      on: {
        mousemove: _vm.handleMove,
        touchmove: _vm.handleMove,
        mousedown: _vm.handleDown,
        touchstart: _vm.handleDown,
        mouseup: _vm.handleUp,
        touchend: _vm.handleUp,
        mousewheel: _vm.handleWheel,
        contextmenu: function($event) {
          $event.stopPropagation()
          $event.preventDefault()
          return _vm.showContextMenu($event)
        },
        click: _vm.closeContextMenu
      }
    },
    [
      _vm.isCallFlowLoading
        ? _c("div", { staticClass: "cf-canvas__loader" }, [_c("Loader")], 1)
        : _vm._e(),
      _vm._v(" "),
      _vm.goToNodeSelectMode
        ? _c("div", { staticClass: "cf-canvas__message" }, [
            _vm._v("\n    " + _vm._s(_vm.$t("NODE_SELECTION")) + "\n    "),
            _c(
              "button",
              {
                staticClass: "cf-node__action m-l-10",
                on: { click: _vm.onGoToNodeSelectModeChange }
              },
              [
                _c("i", {
                  staticClass: "fa fa-times",
                  attrs: { "aria-hidden": "true" }
                })
              ]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("CallFlowLinks", {
        attrs: {
          links: _vm.links,
          "temp-link": _vm.tempLink,
          nodes: _vm.nodes,
          container: _vm.containerCopy,
          "node-link-details": _vm.nodeLinkDetailsCopy
        },
        on: { editNodeLinks: _vm.selectLinkOriginNode }
      }),
      _vm._v(" "),
      _vm._l(_vm.nodes, function(node) {
        return _c("Node", {
          key: node.id,
          attrs: {
            node: node,
            options: _vm.optionsForChild,
            "has-child": node.hasChild,
            "node-link-details": _vm.nodeLinkDetailsCopy,
            "enable-dropzone": _vm.linking,
            "new-added": node.newAdded
          },
          on: {
            drag: _vm.nodeDrag,
            showContextMenu: _vm.showContextMenu,
            startConnection: function($event) {
              return _vm.startConnection(node, $event)
            },
            endConnection: function($event) {
              return _vm.endConnection(node, $event)
            },
            selectNode: _vm.selectNode,
            duplicate: function($event) {
              return _vm.nodeDuplicate(node)
            },
            removeConnection: _vm.removeConnection,
            deleteNode: _vm.confirmDeleteNode,
            "update-scene-container": _vm.handleSceneContainerUpdate
          }
        })
      }),
      _vm._v(" "),
      _c("NodeProperties", {
        ref: "nodeProperties",
        attrs: {
          scene: _vm.scene,
          node: _vm.selectedNode,
          "route-to-node": _vm.routeToNode,
          "select-mode-active": _vm.goToNodeSelectMode
        },
        on: {
          "update:scene": function($event) {
            _vm.scene = $event
          },
          deleteNode: _vm.confirmDeleteNode,
          closeNodeProperties: _vm.closeNodeProperties,
          duplicateNode: _vm.onDuplicateNode,
          goToNodeSelectMode: _vm.onGoToNodeSelectModeChange,
          selectNode: _vm.selectNode,
          removeConnection: _vm.removeConnection,
          showContextMenu: _vm.showContextMenu
        }
      }),
      _vm._v(" "),
      _c(
        "ul",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.contextMenu.isActive,
              expression: "contextMenu.isActive"
            }
          ],
          ref: "cfContextMenu",
          staticClass: "cf-context-menu",
          style: _vm.contextMenuStyle
        },
        _vm._l(_vm.nodesAvailableToAdd, function(node, index) {
          return _c(
            "li",
            {
              key: index,
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.drawNode(node)
                }
              }
            },
            [_vm._v("\n      " + _vm._s(node.displayName) + "\n    ")]
          )
        }),
        0
      ),
      _vm._v(" "),
      _c("div", { staticClass: "cf-zoom" }, [
        _c(
          "button",
          {
            on: {
              click: function($event) {
                return _vm.zoomCanvas("+")
              }
            }
          },
          [_vm._v("\n      +\n    ")]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            on: {
              click: function($event) {
                return _vm.zoomCanvas("-")
              }
            }
          },
          [_vm._v("\n      -\n    ")]
        )
      ]),
      _vm._v(" "),
      _vm.showConfirmation
        ? _c("ConfirmationModal", {
            attrs: {
              title: _vm.$t("DELETE_CALL_FLOW_NODE_CONFIRMATION_TITLE"),
              "show-confirm-button": true,
              "show-header-close-button": true,
              "show-custom-button": false
            },
            on: {
              close: function($event) {
                _vm.showConfirmation = false
              },
              confirm: _vm.deleteNode
            }
          })
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }